import { cn } from '../lib/cn.js';
import { TOUCH_MODE } from '../game/touch.js';
import { useGameStore } from '../game/store.js';

/**
 * The microphone state pill. On touch it is the mic toggle itself; on desktop
 * the pointer is locked most of the time, so V does the toggling and the pill
 * is chiefly an unmissable "you are transmitting" indicator — red while live,
 * matching what players expect from Discord and its peers.
 */
export const VoiceButton = ({ onToggle }: { onToggle: () => void }) => {
  const micOn = useGameStore((state) => state.micOn);
  return (
    <button
      onPointerDown={(event) => {
        event.preventDefault();
        onToggle();
      }}
      className={cn(
        'pointer-events-auto fixed z-20 flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold backdrop-blur transition-colors',
        // Touch: in the top-left button row, after pause and scoreboard (the
        // top-right corner belongs to the hub queue cards). Desktop: above
        // the health bar, out of every overlay's way.
        TOUCH_MODE ? 'left-28 top-4' : 'bottom-[4.75rem] left-6',
        micOn
          ? 'border-team-red/70 bg-team-red/30 text-white'
          : 'border-white/15 bg-surface-900/60 text-ink-muted',
      )}
    >
      <span
        className={cn(
          'size-1.5 rounded-full',
          micOn ? 'animate-pulse bg-team-red' : 'bg-white/30',
        )}
      />
      {micOn ? 'Mic live' : 'Mic off'}
      {!TOUCH_MODE && <span className="opacity-60">· V</span>}
    </button>
  );
};
